import styled from 'styled-components';
import { CarvanaTheme } from '@carvana/theme';

const HeaderBase = styled.h1`
  color: ${({ theme = CarvanaTheme }) => theme.carvana.blue.dark};
  font-family: ${({ theme = CarvanaTheme }) => theme.typography.fontFamily};
  font-weight: 700;
  text-transform: uppercase;
`;

const BodyBase = styled.p`
  color: ${({ theme = CarvanaTheme }) => theme.carvana.gray.dark};
  font-family: ${({ theme = CarvanaTheme }) => theme.typography.fontFamily};
  font-weight: 400;
`;

const Link = styled.a`
  cursor: pointer;
  color: ${({ theme = CarvanaTheme }) => theme.carvana.blue.primary};
  font-family: ${({ theme = CarvanaTheme }) => theme.typography.fontFamily};
  line-height: 20px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export { BodyBase, HeaderBase, Link };
